import type { LinkingMatrix } from '../types';

const ALPHA_LENS_SYMBOL_TARGETS: LinkingMatrix['alpha-lens'] = [
    'trade-pro',
    'trade-pro-multi',
    'alpha-lens',
    'tradingview-chart',
    'searchalpha',
    'screener',
    'scanner',
    'news',
    'events',
    'filings',
    'alerts',
];

export const MATRIX: LinkingMatrix = {
    results: [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'locates',
        'lab',
        'tradingview-chart',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'news',
        'events',
        'filings',
        'alerts',
    ],
    watchlist: [
        'watchlist',
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'locates',
        'lab',
        'tradingview-chart',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'news',
        'events',
        'filings',
        'alerts',
    ],
    'order-blotter': [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'tradingview-chart',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'news',
        'events',
        'filings',
    ],
    'trade-pro': ['tradingview-chart', 'alerts'],
    'trade-pro-multi': ['tradingview-chart', 'alerts'],
    'basket-trading': [],
    'manual-review': [],
    messages: ['order-blotter', 'trade-pro', 'trade-pro-multi', 'messages', 'positions', 'executions', 'orders'],
    positions: [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'positions',
        'executions',
        'orders',
        'locates',
        'lab',
        'tradingview-chart',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'news',
        'events',
        'filings',
        'alerts',
    ],
    executions: [
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'executions',
        'tradingview-chart',
        'alpha-lens',
        'searchalpha',
        'screener',
        'scanner',
        'news',
        'events',
        'filings',
        'alerts',
    ],
    accounts: [], // No symbol linking in accounts
    orders: [
        'order-blotter',
        'trade-pro',
        'trade-pro-multi',
        'messages',
        'executions',
        'tradingview-chart',
        'alpha-lens',
        'news',
        'events',
        'filings',
        'alerts',
    ],
    locates: [
        'trade-pro',
        'trade-pro-multi',
        'tradingview-chart',
        'alpha-lens',
        'locates',
        'lab',
        'searchalpha',
        'screener',
        'scanner',
        'news',
        'events',
        'filings',
    ],
    lab: [
        'trade-pro',
        'trade-pro-multi',
        'tradingview-chart',
        'alpha-lens',
        'locates',
        'lab',
        'searchalpha',
        'screener',
        'scanner',
        'news',
        'events',
        'filings',
    ],
    table: [],
    'alpha-lens': ALPHA_LENS_SYMBOL_TARGETS,
    searchalpha: ['tradingview-chart', 'alpha-lens', 'searchalpha', 'screener', 'scanner', 'events', 'news', 'filings'],
    scanner: ['tradingview-chart', 'alpha-lens', 'searchalpha', 'screener', 'scanner', 'events', 'news', 'filings'],
    screener: ['tradingview-chart', 'alpha-lens', 'searchalpha', 'screener', 'scanner', 'events', 'news', 'filings'],
    news: [
        'trade-pro',
        'trade-pro-multi',
        'tradingview-chart',
        'alpha-lens',
        'searchalpha',
        'scanner',
        'screener',
        'news',
        'events',
        'filings',
    ],
    events: [
        'trade-pro',
        'trade-pro-multi',
        'tradingview-chart',
        'alpha-lens',
        'searchalpha',
        'scanner',
        'screener',
        'news',
        'events',
        'filings',
    ],
    filings: [
        'trade-pro',
        'trade-pro-multi',
        'tradingview-chart',
        'alpha-lens',
        'searchalpha',
        'scanner',
        'screener',
        'news',
        'events',
        'filings',
    ],
    notepad: [], // notepad does not link to or from anything
    'alpha-eye': ALPHA_LENS_SYMBOL_TARGETS,
    platforms: [],
    symbols: [],
    traders: [],
    alerts: [], // alerts receives symbols but does not send them
    backtest: [],
    'tradingview-chart': [
        'trade-pro',
        'trade-pro-multi',
        'alpha-lens',
        'tradingview-chart',
        'searchalpha',
        'screener',
        'scanner',
        'news',
        'events',
        'filings',
        'alerts',
    ],
};
